import React from 'react';

const PageNotFound = () => {
  return (
    <div>
      <div>Page Not Found</div>
    </div>
  );
};

export default PageNotFound;
